import React from "react"
import { Button, CircularProgress } from "@/shared/ui"
import { fetchRepairCounts, cancelRepair, nudgeOhlcvRunner } from "@/modules/crypto-assets/services/repairService"
import { useAuth } from "@/modules/auth/context/AuthContext"
import { isMasterByEmail } from "@/shared/utils/role"
import RepairJobsModal from "./RepairJobsModal"

export default function RepairJobIndicator() {
  const [jobId, setJobId] = React.useState<string | null>(null)
  const [open, setOpen] = React.useState(false)
  const [counts, setCounts] = React.useState<{ total: number; pending: number; enqueued: number; done: number; failed: number } | null>(null)
  const { user, profile } = useAuth()
  const isMaster = isMasterByEmail(user?.email) || profile?.role === 'master'

  React.useEffect(() => {
    const read = () => { try { setJobId(localStorage.getItem('activeRepairJobId')) } catch {} }
    read()
    const t = setInterval(read, 3000)
    const onStorage = (e: StorageEvent) => { if (e.key === 'activeRepairJobId') read() }
    window.addEventListener('storage', onStorage)
    return () => { clearInterval(t); window.removeEventListener('storage', onStorage) }
  }, [])

  React.useEffect(() => {
    if (!jobId) return
    let alive = true
    const tick = async () => { try { const c = await fetchRepairCounts(jobId); if (alive) setCounts(c) } catch {} }
    tick()
    const t = setInterval(tick, 6000)
    return () => { alive = false; clearInterval(t) }
  }, [jobId])

  if (!isMaster || !jobId) return null
  const total = counts?.total ?? 0
  const done = counts?.done ?? 0
  const failed = counts?.failed ?? 0
  const enq = counts?.enqueued ?? 0
  const finished = total > 0 && (done + failed) >= total
  const pct = total ? Math.max(0, Math.min(100, Math.round((done / total) * 100))) : 0
  const state = finished ? 'Conclu�do � pode fechar' : (enq > 0 ? 'Processando no servidor�' : 'Aguardando�')

  return (
    <>
      <div className="fixed bottom-16 right-4 z-[100001] w-[260px] rounded-md border border-border bg-background/95 p-3 shadow-lg">
        <div className="mb-2 flex items-center gap-2 text-xs text-foreground/80">
          <CircularProgress value={pct} className="text-emerald-500" />
          <div>
            <div className="font-medium text-foreground">Reparo em lote</div>
            <div className="text-foreground/70">{state}</div>
          </div>
        </div>
        <div className="text-sm font-medium">{done}/{total} <span className="text-foreground/60">{failed ? `(falhas ${failed})` : ''}</span></div>
        <div className="mt-2 flex items-center gap-2">
          <Button variant="default" className="px-2 py-1 text-xs" onClick={() => setOpen(true)}>Abrir</Button>
          <Button variant="outline" className="px-2 py-1 text-xs" onClick={() => { try { nudgeOhlcvRunner({ limit: 60, budgetMs: 35000 }) } catch {} }}>For�ar runner</Button>
          <Button variant="ghost" className="px-2 py-1 text-xs" onClick={async ()=>{ try { await cancelRepair(jobId); localStorage.removeItem('activeRepairJobId'); setJobId(null) } catch {} }}>Cancelar</Button>
        </div>
      </div>
      {open && (<RepairJobsModal open={open} onOpenChange={(v)=> setOpen(v)} />)}
    </>
  )
}



